// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1kplp","title":"Info_title__3zuH_","links":"Info_links__2E8IK","link":"Info_link__x7HLB","logo":"Info_logo__2siiE"};